import gtm from "../utils/GTM";
import FormsExtend from "./forms-extend";
import FormsValidation from "./forms-validation";

interface EpiformsEvent extends Event {
  isFinalizedSubmission: boolean;
  workingFormInfo: {
    Id: string;
    Name: string;
  };
}

declare const $$epiforms: (selector: string | Document) => {
  ready: (callback: () => void) => void;
  on: (event: string, handler: (e: EpiformsEvent) => void) => void;
};

const Forms = (function () {
  function init() {
    if ($("form").length) {
      waitForEpiForms(setupFields);
      waitForEpiForms(initGtm);
      FormsExtend.init();
      FormsValidation.init();
    }
  }

  function waitForEpiForms(callback: () => void) {
    let attempts = 0;
    const maxAttempts = 20;
    const interval = 10;

    const intervalId = setInterval(function () {
      attempts++;
      if (typeof $$epiforms !== "undefined") {
        clearInterval(intervalId); // Stop retrying
        callback(); // Execute the passed function
      } else if (attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, interval);
  }

  function setupFields(): void {
    // Update the text character counter on textfields
    $(".custom-textarea").on("keyup", "textarea", function () {
      updateCharCounter(this);
    });

    // Trigger click on file upload when clicking upload-files-link
    $(".js-fileContainer-add-files").on("click", function () {
      $(this)
        .closest(".js-fileContainer")
        .find(".js-fileContainer-input")
        .trigger("click");
    });

    // Set individual file names for upload element
    $("form").on("change", ".js-fileContainer-input", function () {
      setFileName(this);
    });

    // Clear individual file names for upload elemenet
    $(".js-fileContainer-clear-files").on("click", function () {
      removeFiles(this);
    });

    // Show/hide textfields connected to checkboxes
    $(".FormChoice .FormChoice__Input--Checkbox").on("click", function () {
      toggleCorrespondingTextField(this);
    });

    // Append values of textfields connected to checkbox/radio to value of the checkbox/radio input for it to be submitted
    $(".FormChoice input[type=text]").on("change", function () {
      addToFormChoiceValue(this);
    });

    // Bind the buttons to show a specific form (for MultipleFormsPage)
    $("button.form-block-select-button").on("click", function () {
      showForm($(this).data("form"));
    });

    // Show a lonely form right away (for FormPage)
    if ($(".form-page form").length === 1) {
      $(".form-page form").removeClass("form-hidden");
    }

    // Add an asterisk to labels with required inputs
    $("input[required], textarea[required]")
      .not(".ignore-required-asterisk")
      .each(function () {
        const textInputElementId = $(this).attr("id");
        $('label[for="' + textInputElementId + '"]').append("*");
      });

    // Initialize floating label animation events on text inputs
    $("input.FormTextbox__Input, textarea.FormTextbox__Input").on(
      "blur",
      function () {
        $(this).parent().removeClass("FormTextbox__Input__Active");

        if ($(this).val() === "") {
          $(this).parent().removeClass("FormTextbox__Input__Filled");
        } else {
          $(this).parent().addClass("FormTextbox__Input__Filled");
        }
      },
    );

    // Initialize floating label animation events on text inputs
    $("input.FormTextbox__Input, textarea.FormTextbox__Input").on(
      "focus",
      function () {
        $(this).parent().addClass("FormTextbox__Input__Active");
      },
    );

    // Initialize (hide) text fields toggled by checkboxes
    initFormChoiceTextFields();

    // Setup of partially filled-out forms
    if (typeof $$epiforms !== "undefined") {
      $$epiforms(".EPiServerForms").on("formsSetupCompleted", function (event) {
        // Floating labels
        initFloatingLabels($("form#" + event.workingFormInfo.Id));

        // Text fields toggled by checkboxes
        initFormChoiceTextFields();
      });
    }
  }

  function showForm(formGuid: string) {
    $("form").each(function () {
      if ($(this).attr("id") === formGuid) {
        $(this).removeClass("form-hidden");
      } else {
        $(this).addClass("form-hidden");
      }
    });

    $("button.form-block-select-button").each(function () {
      if ($(this).data("form") === formGuid) {
        $(this).addClass("selected");
      } else {
        $(this).removeClass("selected");
      }
    });
  }

  function initFloatingLabels(formElement: JQuery<HTMLElement>) {
    $(
      "input.FormTextbox__Input, textarea.FormTextbox__Input",
      formElement,
    ).each(function () {
      if ($(this).val() !== "") {
        $(this).parent().addClass("FormTextbox__Input__Filled");
      }
    });
  }

  function setFileName(fileUploadInput: HTMLInputElement) {
    const $fileUploadContainer =
      $(fileUploadInput).closest(".js-fileContainer");
    const $fileNames = $fileUploadContainer.find(
      ".js-fileContainer-file-names",
    );
    const files = $(fileUploadInput)[0].files;

    if (files && files.length > 0) {
      let selectedFilesText = "";
      if (files.length === 1) {
        selectedFilesText +=
          files[0].name + " (" + GetFileSizeInMb(files[0].size) + " MB)";
      } else {
        selectedFilesText +=
          $fileNames.data("files-label") + " (" + files.length + "):";
        for (let i = 0; i < files.length; i++) {
          selectedFilesText +=
            "\n• " +
            files[i].name +
            " (" +
            GetFileSizeInMb(files[i].size) +
            " MB)";
        }
      }
      $fileNames.text(selectedFilesText);
      $fileUploadContainer.addClass("has-file");
    } else {
      $fileNames.text("");
      $fileUploadContainer.removeClass("has-file");
    }

    function GetFileSizeInMb(fileSizeInB: number) {
      return Math.round((fileSizeInB / 1048576) * 100) / 100;
    }
  }

  function removeFiles(removeFilesBtn: HTMLElement) {
    const $fileUploadContainer = $(removeFilesBtn).closest(".js-fileContainer");
    const $fileNames = $fileUploadContainer.find(
      ".js-fileContainer-file-names",
    );
    const $fileUpload = $fileUploadContainer.find(".js-fileContainer-input");

    $fileUpload.val("").trigger("change");
    $fileNames.text("");
    $fileUploadContainer.removeClass("has-file");
  }

  function updateCharCounter(textarea: HTMLTextAreaElement) {
    const characterCount = $(textarea).val()!.length;
    const counterElement = $(
      "[data-counter-for=" + $(textarea).attr("id") + "]",
    );

    counterElement.text(characterCount);
  }

  function initFormChoiceTextFields() {
    $(".FormChoice .formchoice-wrapper").each(function () {
      const $checkboxInput = $(this)
        .find(".FormChoice__Input--Checkbox")
        .first();
      const $textFieldWrapper = $(this).find(".FormTextbox").first();
      const isChecked = $checkboxInput.is(":checked");

      if (isChecked) {
        $textFieldWrapper.show();
      } else {
        $textFieldWrapper.hide();
      }
    });
  }

  function toggleCorrespondingTextField(checkboxInput: HTMLElement) {
    const $textFieldWrapper = $(checkboxInput)
      .parent()
      .find(".FormTextbox")
      .first();
    const isChecked = $(checkboxInput).is(":checked");

    if (isChecked) {
      $textFieldWrapper.show();
    } else {
      $textFieldWrapper.hide();
    }
  }

  function addToFormChoiceValue(textField: HTMLElement) {
    const $this = $(textField);
    const id = $this.attr("id");

    // Concatenate the original field value with user specified text from textfield; separator should be ': '
    const $formChoiceInput = $("input[data-field-id=" + id + "]");
    const cleanedTextFieldValue = ($this.val() as string).replace(
      /[,.]/g,
      function (m) {
        // EPiServer uses comma for separation so we won't allow it.
        if (m === ",") {
          return ".";
        }
        // do anything with '.' ?
        return m;
      },
    );
    // TODO fix replace breaks validation

    $formChoiceInput.val(
      $formChoiceInput.data("original-value") + ": " + cleanedTextFieldValue,
    );
  }
  // https://docs.developers.optimizely.com/content-management-system/v1.2.0-forms/docs/handling-events-for-forms
  function initGtm(): void {
    if (typeof $$epiforms !== "undefined") {
      $$epiforms(document).ready(function () {
        $$epiforms(".EPiServerForms").on(
          "formsSetupCompleted",
          function (event) {
            if (event.workingFormInfo && event.workingFormInfo.Name)
              // Set the name as data attribute so it can be fetched on the form_started event
              (event.target as HTMLElement).setAttribute(
                "data-name",
                event.workingFormInfo.Name,
              );
          },
        );

        $("form.EPiServerForms").on("input", function (event) {
          if (!$(this).data("changed")) {
            const id = event.currentTarget.id;
            const name = event.currentTarget.getAttribute("data-name");
            gtm.datalayerPush("form_started", {
              form_id: id,
              form_name: name,
            });
          }
          $(this).data("changed", true);
        });

        $$epiforms(".EPiServerForms").on("formsSubmitted", function (event) {
          const id = event.workingFormInfo.Id;
          const name = event.workingFormInfo.Name;
          const markerPlaced =
            document.getElementsByClassName("js-lat-lng-input")[0] &&
            document
              .getElementsByClassName("js-lat-lng-input")[0]
              .getAttribute("data-marker-type");

          if (event.isFinalizedSubmission) {
            gtm.datalayerPush("form_submission", {
              form_id: id,
              form_name: name,
              ...(!!markerPlaced && { marker_placed: markerPlaced }),
            });
          } else {
            gtm.datalayerPush("form_step", {
              form_id: id,
              form_name: name,
            });
          }
        });
      });
    }
  }

  return {
    init,
  };
})();

export default Forms;
